import $ from 'jquery';

$( window ).on( 'load resize', function() {
    if ( $( window ).width() < 1254 ) {
        $( '.js-cta-columns-slider' ).slick( {
            dots: true,
            rows: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            centerPadding: '32px',
            responsive: [
                {
                    breakpoint: 1254,
                    settings: {
                        adaptiveHeight: true,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        adaptiveHeight: true,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        adaptiveHeight: true,
                        arrows: false,
                        slidesToShow: 1,
                    }
                }
            ],
        } );
    } else {
        $( '.js-cta-columns-slider' ).slick( 'unslick' );
    }
});